export const organizationDetailPage = () =>
  import("./OrganizationDetailPage").then((m) => ({
    Component: m.OrganizationDetailPage,
  }));
